import AxiosInstance from "./api";

export const AccountingSystemService = {
  getAll: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/accounting-system?" + query.toString());
  },
  getByBalance: async (type) => {
    return await AxiosInstance.get("/private/accounting-system/balance?type=" + type);
  },
};
